import {appendPaginationQueryParamsToUrl, get} from '../utils'

const url = (host, type , tags, notTags, search, types, options) =>
  appendPaginationQueryParamsToUrl(`${host}/contentCreations?${type !== "all" ? `content_type=${type}` : "" }${types.length>0 ?  `&types=${types.join(',')}` : "" }&tags_ids=${tags.join(',')}${search == "" ? "" : `&q=${search}`}&home=true=&active=1&type=talent&include=tags;image;binary;video.thumbnail;audio.waveform;embededContent;contentCreator.image;favorite`, {...options, alreadyHasQueryParams: true});

export default host => (type, tags, notTags, search, types, options) =>
  get(url(host, type, tags, notTags, search, types, options))
    .then(response => response.json())
    .then(json => json.meta ? json : json.data)